export { useUpdateOONConsentQuery } from './useUpdateOONConsentQuery';
